import decorService from '../../services/ClassenService/modules/decorService';

const state = {
  decors: [],
  decorsFacets: [],
  decorQuickSelections: []
};

const mutations = {
  SET_DECORS(products) {
    state.decors = products;
  },

  ADD_DECOR_QUICKSELECTION(state, selectionItem) {
    state.decorQuickSelections.push(selectionItem);
  }
};

const getters = {
  getDecors: (state) => () => state.decors,

  getDecorsFacets: (state) => () => state.decorsFacets,

  getDecorQuickSelections() {
    return state.decorQuickSelections;
  }
};

const actions = {
  searchDecors: (context, {page, size, queryData}) => new Promise((resolve, reject) => {
    decorService.searchDecors(page, size, queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  getDecor: ({commit}, decorId) => new Promise((resolve, reject) => {
    decorService.getDecor(decorId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addSearchDecorsToSelection: (context, queryData) => new Promise((resolve, reject) => {
    decorService.addSearchDecorsToSelection(queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  removeSearchDecorFromSelection: (context, queryData) => new Promise((resolve, reject) => {
    decorService.removeSearchFromSelection(queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  getDecorQuickSelection: (context, decorId) => {
    let selectionItem = context.state.decorQuickSelections.find((quick) => {
      return quick.decorId === decorId
    })

    if (!selectionItem) {
      decorService.getDecorQuickSelection(decorId)
        .then((res) => {
          context.commit('ADD_DECOR_QUICKSELECTION', {decorId: decorId, quickSelection: res.data})
        });
    }

    return context.state.productQuickSelections
  },

  forceUpdateQuickSelectionDecor: (context, decorId) => {
    let selectionItem = context.state.decorQuickSelections.find((quick) => {
      return quick.decorId === decorId
    })

    let index = context.state.decorQuickSelections.indexOf(selectionItem);
    context.state.decorQuickSelections.splice(index, 1);

    decorService.getDecorQuickSelection(decorId)
      .then((res) => {
        context.commit('ADD_DECOR_QUICKSELECTION', {decorId: decorId, quickSelection: res.data})
      });
  },

  addDecor: ({commit}, decorData) => new Promise((resolve, reject) => {
    decorService.addDecor(decorData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateDecor: ({commit}, decorId, decorData) => new Promise((resolve, reject) => {
    decorService.updateDecor(decorId, decorData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteDecor: ({commit}, decorId) => new Promise((resolve, reject) => {
    decorService.deleteDecor(decorId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getDecorFacets: ({commit}) => new Promise((resolve, reject) => {
    decorService.getDecorsFacets()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
